import clsx from "clsx";
import "./DoctorModalContent.scss";

type DoctorModalContentProps = {
  overrideClassNames?: string;
  children?: React.ReactNode;
};

export const DoctorModalContent = ({
  overrideClassNames,
  children,
}: DoctorModalContentProps) => {
  return (
    <div className={clsx("ui-consent-modal-body", overrideClassNames)}>
      {children}
    </div>
  );
};
